import {
  AttachmentContent,
  CarePlanContentInput,
} from "@/api/generated/models";
import VideoVisitStatus from "../video/VideoVisitStatus";
import Attachment from "./Attachment";
import CarePlan from "./CarePlan";
import ClinicianBio from "./ClinicianBio";
import OutputText from "./OutputText";
import SystemMessage from "./SystemMessage";

export type CuraiMessageTypes =
  | "care_plan"
  | "output_text"
  | "clinician_bio"
  | "system"
  | "attachment"
  | "video_visit_started"
  | "video_visit_ended";

export type CuraiMessageProps = {
  content: any;
  messageId: string;
  type: CuraiMessageTypes;
  senderPhotoUrl?: string;
  senderFullNameWithTitle?: string;
};

export default function CuraiMessage(props: CuraiMessageProps) {
  switch (props.type) {
    case "care_plan":
      return (
        <CarePlan {...props} content={props.content as CarePlanContentInput} />
      );
    case "clinician_bio":
      return <ClinicianBio {...props} content={props.content as string} />;
    case "system":
      return <SystemMessage {...props} content={props.content as string} />;
    case "attachment":
      return (
        <Attachment {...props} content={props.content as AttachmentContent} />
      );
    case "video_visit_started":
    case "video_visit_ended":
      return <VideoVisitStatus content={props.content as string} />;
    case "output_text":
    default:
      return <OutputText {...props} content={props.content as string} />;
  }
}
